import { UserType } from "src/common/enums";

export function isEmptyString(str: string | null | undefined): boolean {
    return !str || str.length === 0;
}

export function isPrimaryAdminRole(role: string): boolean {
    return role === UserType.ABBM_PRIMARY || role === UserType.USER_ADMIN_PRIMARY;
}